// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"b32be9ca","213":"825a9ce7","410":"f0ca3b4a","420":"acf42496","453":"090fa758","551":"aaab50db","756":"ed925ab1","947":"7f842ffc","971":"a1438ae4","996":"24f93a80"}[chunkId] + ".chunk.js";
};